"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewType = void 0;
const validation_1 = require("../../validation");
/** @alpha */
var PreviewType;
(function (PreviewType) {
    PreviewType["TEXTURE"] = "texture";
    PreviewType["WEARABLE"] = "wearable";
    PreviewType["AVATAR"] = "avatar";
})(PreviewType = exports.PreviewType || (exports.PreviewType = {}));
/** @alpha */
(function (PreviewType) {
    PreviewType.schema = {
        type: 'string',
        enum: Object.values(PreviewType)
    };
    PreviewType.validate = (0, validation_1.generateLazyValidator)(PreviewType.schema);
})(PreviewType = exports.PreviewType || (exports.PreviewType = {}));
//# sourceMappingURL=preview-type.js.map